var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartDark = function SvgCartDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.636 12.081c.774 0 1.455-.423 1.806-1.062l3.694-6.696a1.028 1.028 0 0 0-.898-1.527H4.968L3.999.732H.626v2.064h2.063l3.715 7.83-1.393 2.518c-.753 1.382.237 3.064 1.805 3.064h12.38v-2.063H6.816L7.95 12.08h7.686ZM5.95 4.86h12.535l-2.848 5.159H8.394L5.949 4.859Zm.866 12.38a2.06 2.06 0 0 0-2.053 2.064 2.06 2.06 0 0 0 2.053 2.064 2.07 2.07 0 0 0 2.064-2.064 2.07 2.07 0 0 0-2.064-2.063Zm10.317 0a2.06 2.06 0 0 0-2.053 2.064 2.06 2.06 0 0 0 2.053 2.064 2.07 2.07 0 0 0 2.064-2.064 2.07 2.07 0 0 0-2.064-2.063Z",
    fill: "#004152"
  })));
};
export default SvgCartDark;